module.exports = __webpack_public_path__ + "img/PhotoExhibit-Haiti.ef741ea8.jpg";